import React, { useState, useRef, useEffect,useCallback } from 'react';
import axios from 'axios';
import { FaMicrophone } from "react-icons/fa";
import { MdOutlineCancel } from "react-icons/md";
import { BsRecordCircle } from "react-icons/bs";
import { RiSendPlane2Fill } from "react-icons/ri";
import { API_URL } from '../../config';
import { toast } from 'react-toastify';

const AudioRecorder = ({ phone, onRecordingChange }) => {
    const [isRecording, setIsRecording] = useState(false);
    const [isRecordingCanceled, setIsRecordingCanceled] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);

    const startRecording = async () => {
        try {
            setIsRecording(true);
            setIsRecordingCanceled(false);
            setAudioBlob(null);
            onRecordingChange(true);
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
            const preferredMimeType = [
                'audio/webm;codecs=opus',
                'audio/ogg;codecs=opus',
                'audio/mp4'
            ].find(type => MediaRecorder.isTypeSupported(type));
            const mediaRecorder = preferredMimeType
                ? new MediaRecorder(stream, { mimeType: preferredMimeType })
                : new MediaRecorder(stream);
            mediaRecorderRef.current = mediaRecorder;

            audioChunksRef.current = [];

            mediaRecorder.addEventListener('dataavailable', event => {
                audioChunksRef.current.push(event.data);
            });

            mediaRecorder.addEventListener('stop', () => {
                const audioBlob = new Blob(audioChunksRef.current, {
                    type: mediaRecorder.mimeType || 'audio/webm'
                });
                setAudioBlob(audioBlob);
                audioChunksRef.current = [];
                stream.getTracks().forEach(track => track.stop());
            });

            mediaRecorder.start();
        } catch (error) {
            console.error('Error accessing microphone:', error);
        }
    };

    const cancelRecording = () => {
        setIsRecording(false);
        setIsRecordingCanceled(true);
        onRecordingChange(false);
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
        }
        audioChunksRef.current = [];
        setAudioBlob(null);
    };

    const stopRecording = () => {
        setIsRecording(false);
        onRecordingChange(false);
        if (mediaRecorderRef.current) {
            mediaRecorderRef.current.stop();
        }
    };

    const sendAudioFile = useCallback(async (audioBlobToSend) => {
        if (!audioBlobToSend || isRecording || isRecordingCanceled) return;

        try {
            const formData = new FormData();
            const extension = audioBlobToSend.type.includes('mp4')
                ? 'm4a'
                : audioBlobToSend.type.includes('ogg')
                    ? 'ogg'
                    : 'webm';
            const filename = `audio.${extension}`;
            formData.append('file', audioBlobToSend, filename);

            const uploadResponse = await axios.post(`${API_URL}uploadaudio`, formData, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            const uploadResult = uploadResponse.data;

            await axios.post(`${API_URL}sendWhatsappImage`, {
                to: phone,
                url: uploadResult.url,
                mimeType: uploadResult.mimeType || audioBlobToSend.type,
                filename: uploadResult.filename || filename,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            setAudioBlob(null);
            toast.success('تم إرسال التسجيل بنجاح');
        } catch (error) {
            console.error('Error:', error);
            toast.error(
                error.response?.data?.msg ||
                error.response?.data?.error ||
                'تعذر إرسال التسجيل'
            );
        }
    }, [isRecording, isRecordingCanceled, phone]);

    useEffect(() => {
        if (!isRecording && audioBlob) {
            sendAudioFile(audioBlob);
        }
    }, [isRecording, audioBlob, sendAudioFile]);

    useEffect(() => {
        if (!isRecording && audioBlob === null) {
            audioChunksRef.current = [];
        }
    }, [isRecording, audioBlob]);


    return (
        <>
        {isRecording ? (
        <div className="audio-recorder icon-container">
            <RiSendPlane2Fill className="icons-record icon-speed-fast" onClick={stopRecording} />
            <MdOutlineCancel className="icons-record icon-speed-medium" onClick={cancelRecording} />
            <BsRecordCircle className="icons-record icon-recording" />
        </div>
        ) : (
            <div className="audio-start-record">
                <FaMicrophone className="icon icon-start-recording" onClick={startRecording} />
            </div>
            )}
        </>
    );
};

export default AudioRecorder;
